var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Modal } from '@wildberries/ui-kit';
import { bindActionCreators } from 'redux';
import { getConfirmModalParams, getIsConfirmModalOpened, getConfirmActionParams, getConfirmModalIsLoading, closeConfirmModalAction, confirmModalStartActionSaga, } from '../redux-module';
var WrappedContainer = /** @class */ (function (_super) {
    __extends(WrappedContainer, _super);
    function WrappedContainer() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.confirmModal = function () {
            var confirmActionParams = _this.props.confirmActionParams;
            if (confirmActionParams) {
                _this.props.confirmModalStart(confirmActionParams);
            }
        };
        _this.closeModal = function () {
            var _a = _this.props.confirmModalParams.cancelButtonProps, action = _a.action, callback = _a.callback;
            if (action) {
                _this.props.dispatch(action());
            }
            if (callback) {
                callback();
            }
            _this.props.closeConfirmModal();
        };
        _this.getModalConfirmPropsConfig = function () {
            return _this.props.confirmModalParams.confirmButtonProps
                ? {
                    actionButton: {
                        onClick: _this.confirmModal,
                        type: 'button',
                        isLoading: _this.props.isConfirmModalLoading,
                        size: 'big',
                        title: _this.props.confirmModalParams.confirmButtonProps.text,
                        variant: 'main',
                    },
                    cancelButton: {
                        onClick: _this.closeModal,
                        type: 'button',
                        isLoading: false,
                        size: 'big',
                        title: _this.props.confirmModalParams.cancelButtonProps.text,
                        variant: 'interface',
                    },
                }
                : {
                    cancelButton: {
                        onClick: _this.closeModal,
                        type: 'button',
                        isLoading: false,
                        size: 'big',
                        title: _this.props.confirmModalParams.cancelButtonProps.text,
                        variant: 'interface',
                    },
                };
        };
        return _this;
    }
    WrappedContainer.prototype.render = function () {
        var _a = this.props.confirmModalParams, content = _a.content, title = _a.title, _b = _a.size, size = _b === void 0 ? 'm' : _b, _c = _a.titleSize, titleSize = _c === void 0 ? 'h1' : _c;
        return (React.createElement(Modal, { actionsConfig: this.getModalConfirmPropsConfig(), isShowCloseIcon: true, isOpened: this.props.isConfirmModalOpened, onClose: this.props.closeConfirmModal, title: title, titleSize: titleSize, size: size }, content));
    };
    return WrappedContainer;
}(Component));
export { WrappedContainer };
var mapStateToProps = function (state) { return ({
    isConfirmModalOpened: getIsConfirmModalOpened(state),
    confirmModalParams: getConfirmModalParams(state),
    confirmActionParams: getConfirmActionParams(state),
    isConfirmModalLoading: getConfirmModalIsLoading(state),
}); };
var mapDispatchToProps = function (dispatch) {
    return bindActionCreators({
        closeConfirmModal: closeConfirmModalAction,
        confirmModalStart: confirmModalStartActionSaga,
        dispatch: dispatch,
    }, dispatch);
};
export var ConfirmModal = connect(mapStateToProps, mapDispatchToProps)(WrappedContainer);
